import { gql } from '@apollo/client';

export const SIGN_UP = gql`
mutation signUp($input:userInput){
  signUp(input:$input){
    _id
    name
    email
    type,
    companyId
  }
}

`
export const SIGN_IN = gql`
mutation customerLogin($email:String , $password:String, $companyId:String){
  customerLogin(email:$email , password:$password, companyId:$companyId){
    token
    user{
      _id
      name
      isEmailVerify
      isAdmin
      email
    }
  }
}

`
export const VERIFY_EMAIL = gql`
mutation verifyEmail($code:String ){
  verifyEmail(code:$code ){
    token
    user{
      _id
      name
      isEmailVerify
      isAdmin
      email
      companyId
    }
  }
}
`
export const RESEND_EMAIL = gql`
mutation resendVerificationEmail($email: String, $companyId:String, $domain: String) {
  resendVerificationEmail(email: $email, companyId: $companyId, domain: $domain)
}
`
export const FORGOT_PASSWORD = gql`
mutation forgotPassword($email:String , $domain:String, $companyId:String ){
  forgotPassword(email:$email, domain:$domain, companyId:$companyId)
}
`
export const RESET_PASSWORD = gql`
mutation verifyForgotPassword($code:String , $password:String ){
  verifyForgotPassword(code:$code, password:$password )
}
`